import { resultMessage } from "./approvalPipeline";

type Result = {
  status?: string | null;
  message?: string | null;
  code?: string | null;
};

export function firstFailedMessage(...lists: Result[][]): string | null {
  return (
    lists
      .flat()
      .filter((result) => String(result.status).toUpperCase() === "FAILED")
      .map(resultMessage)
      .find(Boolean) ?? null
  );
}
